// export function formatOpeningHoursToday(openingHours) {
//   const days = [
//     "sunday",
//     "monday",
//     "tuesday",
//     "wednesday",
//     "thursday",
//     "friday",
//     "saturday",
//   ];
//   const today = days[new Date().getDay()];
//   const todayHours = openingHours?.[today];

//   if (todayHours && todayHours.length > 0) {
//     const [open, close] = todayHours[0].split("-");
//     return { [new Date().getDay()]: { open, close } };
//   }

//   return { [new Date().getDay()]: null };
// }
// export function formatOpeningHoursToday(openingHours) {
//   const days = [
//     "sunday",
//     "monday",
//     "tuesday",
//     "wednesday",
//     "thursday",
//     "friday",
//     "saturday",
//   ];

//   const todayIndex = new Date().getDay(); // 0 = Sunday
//   const todayKey = days[todayIndex];
//   const todayHours = openingHours?.[todayKey];

//   let result = { [todayIndex]: null };

//   if (Array.isArray(todayHours) && todayHours.length > 0) {
//     const raw = todayHours[0]?.trim().toLowerCase();

//     if (raw && raw !== "closed") {
//       const [open, close] = raw.split("-");
//       if (open && close) {
//         result[todayIndex] = { open, close };
//       }
//     }
//   }

//   return result;
// }
export function formatOpeningHoursToday(openingHours) {
  const days = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];

  const todayIndex = new Date().getDay(); // 0 = Sunday
  const todayKey = days[todayIndex];
  const todayHours = openingHours?.[todayKey];

  // Default to closed
  const result = { [todayIndex]: "Closed" };

  if (Array.isArray(todayHours) && todayHours.length > 0) {
    const raw = todayHours[0]?.trim().toLowerCase();

    if (raw && raw !== "closed" && raw.includes("-")) {
      const [open, close] = raw.split("-");
      if (open && close) {
        result[todayIndex] = { open: open.trim(), close: close.trim() };
      }
    }
  }

  return result;
}

